import React from 'react'

const PurposePage = () => {
  return (
    <div className="about-section">
      <span className="about-label">Purpose</span>
      <div className="about-gold-bar" />
      <p className="about-body">
        To close the gap between strategy and execution—so transformation
        delivers real, measurable impact, not just intent.
      </p>
    </div>
  );
}

export default PurposePage